export class Categoria {
    id: number;
    nombre: string;
    idIdioma: number;
    color:string;
    filled:boolean;
}